import { ApolloClient, InMemoryCache } from '@apollo/client';
import { apolloLink } from '../../../../../shared/data/apolloClient';

const mobileWorkspacesDetailsApolloClient = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache({}),
});

export default mobileWorkspacesDetailsApolloClient;
